import type { GetUserTerminateAccountDetailsResponse } from '@/api/user/types';

export const selectTotalOutstandingDebt = (outstandingDebt: GetUserTerminateAccountDetailsResponse) =>
  Object.values(outstandingDebt).reduce(
    (totalOutstandingDebt, product) => totalOutstandingDebt + (product?.debt ?? 0),
    0,
  );
